<template>
  <div>
    <transition>
      <div class="microphoneSetting flexcenter">
        <div class="microphoneSettingDialog flexcenter">
          <div class="align-left">
            <p>音声による入力が必要ですが、マイクから音声が正しく入力されていません。</p>
            <p v-if="isMobile()">[音声機能]をオフにしますか？</p>
            <p v-else>[マイクの設定]を開きますか？</p>
          </div>
          <div class="flexbetween buttons">
            <button class="offbutton" type="button" v-on:click="clickSreOff"><span>音声機能を</span><span>オフにする</span></button>
            <button class="nobutton" type="button" v-on:click="clickButton(false)"><span>いいえ</span><span class="font12">(このまま続ける)</span></button>
            <button class="yesbutton" type="button" v-on:click="clickButton(true)" v-if="!isMobile()"><span>はい</span><span class="font12">(設定を開く)</span></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'
import http from '@/mixin/http'
import * as constants from '@/mixin/constants'

export default {
  name: 'microphoneSettingDialog',
  props: {
    productInfo: Object
  },
  mixins: [
    common,
    http
  ],
  methods: {
    /**
     * SREをoffにする
     */
    clickSreOff: function() {
      this.log("MicrophoneSettingDialog start clickSreOff")

      // storeのデータ更新
      this.$store.dispatch('setSreUse', 'false')

      // key-value設定API呼び出し
      var apiData = '{"data":[' + '{"' + constants.DATA_SETTING_SRE_USE + '":"false"}]}'
      var self = this
      this.doSetKeyValue(apiData)
      .then(function(){
        // 親へ通知
        self.$emit('startLesson')
      })
      .catch(function(message) {
        if(message.length != 0) {
          self.$emit('showError', message, constants.ERROR_BUTTON_KIND_LOGIN)
        } else {
          // 親へ通知
          self.$emit('startLesson')
        }
      })
    },
    /**
     * "はい"、"いいえ"押下時の処理
     */
    clickButton: function(flag) {
      this.log("MicrophoneSettingDialog start clickButton: " + flag)

      if(flag) {
        // マイク設定画面へ遷移
        this.$emit('clickMicrophoneSetting')
      } else {
        // 親へ通知
        this.$emit('lessonContinue')
      }
    },
    /**
     *　key-value設定APIを実行
     */
    doSetKeyValue: function(datajson) {
      this.log("MicrophoneSettingDialog start doSetKeyValue")
      var self = this

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson)
        .then(function(response) {
          self.log("MicrophoneSettingDialog doSetKeyValue resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              resolve()
              break
          }
        })
        .catch(function(err) {
          resolve()
        })
      })
    }
  },
  mounted: function() {
    this.log("MicrophoneSettingDialog start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// MicrophoneSettingDialog.vue?ad57505e